import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  fetchmostPopular,
  mostPopularSelector,
} from "../../../../redux/Slices/Promotions/mostPopular";
import PromotionCarousel from "./PromotionCarousel";
import { useTranslation } from "react-i18next";

const MostPopular = () => {
  const dispatch = useDispatch();
  const state = useSelector(mostPopularSelector);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    dispatch(fetchmostPopular());
  }, [dispatch]);

  if (state.mostPopular?.length > 0) {
    return (
      <PromotionCarousel
        items={state.mostPopular}
        viewText={t("CON_EXPLORE_MOST_POPULAR_PRODUCTS")}
        title='CON_MOST_POPULAR'
      />
    );
  } else {
    return <></>;
  }
};

export default MostPopular;
